/**
 * Used to represent the values that a column can have
 */
export enum InputType {
    email = 'email',
    string = 'text',

    // Custom Field 'numbers' are type `integer`
    integer = 'integer',
    number = 'number',
    date = 'date',
    longText = 'long-text',

    // These two options use selects
    boolean = 'boolean',
    options = 'options',
}
